import React, { Component, PureComponent } from 'react'

export default function Columns({ count = 2, children }) {
  let classes = ['form-columns', `form-columns--${count}`]
  return <div className={classes.join(' ')}>{children}</div>
}
